import React, {useState} from "react";
import {RingLoader} from "react-spinners";
import {useParams} from "react-router-dom";
import LogReport from "../components/Reports/LogReport";
import awsconfig from "../configs/awsconfig.json";

// All known demo IDs across all environments
const DEMO_IDS = [
  "26867c72-b41c-4367-978c-168dca7ed809", // localhost demo
  "b31722e0-a013-46f9-9deb-f2928ecda94a", // dev demo
  "230cbf79-326f-440a-9a4c-6bf30c5b318e" // prod demo
];

const Report = (props: any) => {
  const [data, setData] = React.useState({});
  const {id} = useParams<{id: string}>();
  const [loading, setLoading] = useState(true);

  // Check if this is ANY demo route (not just current environment's demo)
  const isDemo = DEMO_IDS.includes(id || "");
  const url: string = isDemo ? "/testdata/demo-v3.json" : `${awsconfig.PublicShare.hostname}/share/${id}.json`;

  React.useEffect(() => {
    fetch(`${url}`, {
      method: "GET"
    })
      .then((response: any) => response.json())
      .then((data: any) => {
        setData(data);
      })
      .catch(() => {
        setData({});
        //console.log(`err:${err}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [url]);

  return (
    <>
      {loading && (
        <div className="iconWrapper">
          <RingLoader color="#4682b4" size={80} loading={true} />
        </div>
      )}
      {!loading && <LogReport {...data} {...props} isShareable={false} logId={id} isDemo={isDemo} />}
    </>
  );
};

export default Report;
